import { SxProps } from '@mui/material';
import { black, blue, grey7, red2, red3 } from 'app/components/ThemeProvider/colors';

export const inputInfo: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  mb: '8px',
  color: grey7,

  '@media screen and (max-height: 864px)': {
    mb: '6px',
  },
};

export const forgetPassBox: SxProps = {
  mt: '16px',
  display: 'flex',
  justifyContent: 'flex-end',
};

export const forgetPassText: SxProps = {
  fontFamily: 'Yelo',
  color: blue,
  fontSize: '15px',
  textDecoration: 'none',
  cursor: 'pointer',
};

export const warningBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  p: '14px 16px',
  border: `1px solid ${red2}`,
  borderRadius: '10px',
  background: red3,
  mt: '28px',

  '@media screen and (max-height: 864px)': {
    mt: '24px',
  },
};

export const errorText: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  color: black,
};

export const btn: SxProps = {
  width: '100%',
  fontSize: '16px',
  position: 'absolute',
  bottom: 0,
  left: 0,
};
